var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "vueModal",
    style: _vm.modalStyles,
    attrs: {
      "click-to-close": false,
      "delay": 100,
      "scrollable": false,
      "classes": ['ugc-modal', {
        'ugc-new-modal-layout': _vm.showNewConfirmDesignComponents
      }],
      "name": "ugcModal"
    },
    on: {
      "before-close": _vm.beforeClose,
      "before-open": _vm.beforeOpen
    }
  }, [_c('ugc-new-topbar', {
    class: {
      hide: !_vm.showNewConfirmDesignComponents
    },
    on: {
      "close": _vm.close
    }
  }), _c('ugc-topbar', {
    ref: "ugcTopBar",
    class: {
      hide: _vm.showNewConfirmDesignComponents
    }
  }), _c(_vm.activeViewComponent, {
    tag: "component"
  }), _c('ugc-go-back-button', {
    ref: "ugcBackButton",
    class: {
      hide: _vm.showNewConfirmDesignComponents
    }
  }), _c('ugc-bottom-bar', {
    class: {
      hide: !_vm.showNewConfirmDesignComponents
    },
    on: {
      "go-back": _vm.goBack,
      "next": _vm.next,
      "finish": _vm.finish
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }